import React from 'react'
import {useIntl} from 'react-intl'

export default function DeleteFileModal() {
  const {formatMessage} = useIntl()
  return (
    <div
      className='modal fade delete-file-modal-wrapper'
      id='deleteFileModal'
      aria-labelledby='deleteFileLabel'
      aria-hidden='true'
    >
      <div className='modal-dialog modal-dialog-centered'>
        <div className='modal-content'>
          <div className='modal-body'>
            <h6>
              {formatMessage({id: 'Are You sure'})} <br></br>{' '}
              {formatMessage({id: 'you want to delete this file?'})}{' '}
            </h6>
            <div className='d-flex flex-row gap-5 justify-content-center mt-7'>
              <button
                className='btn btn-sm btn-bg-light'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                {formatMessage({id: 'No'})}
              </button>
              <button
                className='btn btn-sm btn-bg-primary text-white'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                {formatMessage({id: 'Yes'})}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
